import React from "react";
import { Wrap } from "./style";
import { data } from "../../utils/navbar";
import { Outlet } from "react-router-dom";
import { FooterPage } from "../../pages/Footer";
const Navbar = () => {
  return (
    <>
      <Wrap>
        <Wrap.LogoWrap>
          <Wrap.NavLink to="/home">
            <Wrap.Logo /> <span> Houzing </span>
          </Wrap.NavLink>
        </Wrap.LogoWrap>
        <Wrap.Ul>
          {data.map(
            (item) =>
              !item?.hidden && (
                <Wrap.Li key={item?.id}>
                  <Wrap.NavLink to={item?.pathname}>{item?.title}</Wrap.NavLink>
                </Wrap.Li>
              )
          )}
        </Wrap.Ul>
      </Wrap>
      <Outlet />
      <FooterPage />
    </>
  );
};
export default Navbar;
